<template>
  <div :class="['detail-tag', { 'detail-edit-tag': isEditing }]">
    <div
      class="btn-box"
      v-if="isCanAlter"
    >
      <el-button
        type="primary"
        v-show="!isEditing"
        @click="isEditing = true"
      >
        修改
      </el-button>
      <el-button
        type="primary"
        v-show="isEditing"
        @click="handleConfirm"
      >
        确认
      </el-button>
      <el-button
        v-show="isEditing"
        @click="handleCancel"
      >
        取消
      </el-button>
    </div>
    <div
      class="empty"
      v-if="isEmpty"
    >
      无标签
    </div>
    <div class="tab-box">
      <span
        v-for="(item, index) in listData"
        :key="index"
      >
        {{ item.keyword }}<i
          class="el-icon-close"
          v-show="isEditing"
          @click="handleClose(index)"
        />
      </span>
      <template v-if="isEditing">
        <el-input
          class="input-new-tag"
          ref="editInput"
          v-if="inputVisible"
          v-model.trim="inputValue"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
          maxlength="10"
        />
        <el-button
          v-else
          class="add-tag"
          size="small"
          @click="showInput"
        >
          <i class="el-icon-plus" />
        </el-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgTab',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isEditing: false,
      listData: [],
      storeData: [],
      inputValue: '',
      inputVisible: false
    }
  },
  computed: {
    isCanAlter() {
      return this.$route.query.isAlter === 'true'
    },
    isEmpty() {
      return !this.isEditing && this.listData.length === 0
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleTagData() {
      this.listData = [...this.detail.tag]
      this.storeData = JSON.parse(JSON.stringify(this.listData))
      this.inputVisible = false
    },
    // 增加标签属性值
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.editInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let isSpace = /^\s*$/.test(this.inputValue)
      if (!isSpace) {
        this.listData.push({
          keyword: this.inputValue,
          score: 0
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleConfirm() {
      this.isEditing = false
      this.$emit('updateDetail', this.listData)
    },
    handleCancel() {
      this.listData = JSON.parse(JSON.stringify(this.storeData))
      this.isEditing = false
    },
    handleClose(index) {
      this.listData.splice(index, 1)
    }
  },
  watch: {
    detail: {
      handler(newVal) {
        if (JSON.stringify(newVal) === '{}' || !newVal.tag) {
          this.listData = []
          return false
        }
        this.handleTagData()
      }
    },
    deep: true,
    immediate: true
  }
}
</script>

<style lang="scss" scoped>
.detail-tag {
  margin-top: 35px;
  position: relative;
  .btn-box {
    position: absolute;
    right: 0;
    top: -25px;
    /deep/ .el-button {
      width: 50px;
      height: 22px;
      padding: 0;
      border-radius: 2px;
      font-size: 13px;
      font-family: "founder_youhei_508R";
      + .el-button {
        margin-left: 8px;
      }
    }
  }
  .tab-box {
    display: flex;
    padding-top:5px;
    margin-bottom:5px;
    font-size: 13px;
    flex-wrap:wrap;
    span {
      display: inline-block;
      height: 25px;
      line-height: 25px;
      padding: 0 8px;
      margin: 0 8px 5px 0;
      color: #4497ec;
      background: rgba(68, 151, 236, 0.2);
      i.el-icon-close {
        margin-left: 8px;
        color: #4497ec;
        cursor: pointer;
        vertical-align: middle;
      }
    }
  }
  .add-tag {
    margin-top:2px;
    width: 30px;
    height: 22px;
    padding: 0;
    background: #f9f9f9;
    border: 1px solid #dcdcdc;
    border-radius: 2px;
    i {
      color: #999;
    }
  }
  .input-new-tag {
    width: 156px;
    /deep/ .el-input__inner {
      height: 25px;
      background-color: #fff;
    }
  }
  .empty {
    margin: 0 !important;
    font-size: 14px;
    color: #999;
    text-align: left !important;
  }
}
</style>
